import React, {ReactElement} from "react";
import {FormGenContentItem, FormGenLayoutSource} from "./FormGenContainer";
import {TextField} from "@mui/material";
import {SZ_XLG} from "./dimens";
import {StyledBoxColumnWithLabel, StyledBoxRow} from "./StyledComponents";

function LatLngTextField({disabled, arrayIndex, arrayNum, contentItem, source}: {
  disabled?: boolean,
  arrayIndex: number,
  arrayNum: number[],
  contentItem: FormGenContentItem,
  source: FormGenLayoutSource,
}): ReactElement {
  return <TextField
    inputMode={"numeric"}
    size="small"
    disabled={disabled}
    style={{width: SZ_XLG, flexGrow: 1}}
    value={arrayNum[arrayIndex]}
    onChange={event => source.setValue(contentItem, [arrayIndex === 0 ? Number.parseFloat(event.target.value) || 0 : arrayNum[0], arrayIndex === 1 ? Number.parseFloat(event.target.value) || 0 : arrayNum[1]])}
    id={contentItem.id}
    variant="outlined"
  />;
}

export function FormGenLatLng(props: {
  contentItem: FormGenContentItem,
  disabled?: boolean,
  index: number,
  source: FormGenLayoutSource,
}): ReactElement {
  let arrayNum: number[] = props.source.getValue(props.contentItem);
  if (!(arrayNum?.length === 2)) {
    arrayNum = [0, 0];
  }
  return <StyledBoxRow>
    <StyledBoxColumnWithLabel style={{flexBasis: 0, flexGrow: 1}} label={"Latitude"}>
      <LatLngTextField
        disabled={props.disabled}
        arrayIndex={0}
        arrayNum={arrayNum}
        contentItem={props.contentItem}
        source={props.source}/>
    </StyledBoxColumnWithLabel>
    <StyledBoxColumnWithLabel style={{flexBasis: 0, flexGrow: 1}} label={"Longitude"}>
      <LatLngTextField
        disabled={props.disabled}
        arrayIndex={1}
        arrayNum={arrayNum}
        contentItem={props.contentItem}
        source={props.source}/>
    </StyledBoxColumnWithLabel>
  </StyledBoxRow>;
}